import React, { Component } from 'react';

class Register extends Component {
  componentDidMount() {
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>

      </div>
    );
  }
}

export default Register;
